module.exports = __webpack_public_path__ + "static/media/image-guide.85c574e0.svg";